
                            const shader = `
#ifdef USE_UV
	varying vec2 vUv;
#endif
#ifdef USE_UV1
	varying vec2 vUv1;
#endif

// VARYINGS
varying vec3 vNormal;
varying vec3 vViewPosition;

#ifdef SIXTY_MAP
	uniform mat3 uMapTransform;
	varying vec2 vMapUv;
#endif

#ifdef SIXTY_ARMMAP
	uniform mat3 uArmMapTransform;
	varying vec2 vArmMapUv;
#endif

#ifdef SIXTY_AOMAP
	uniform mat3 uAoMapTransform;
	varying vec2 vAoMapUv;
#endif

#ifdef SIXTY_EMISSIVEMAP
	uniform mat3 uEmissiveMapTransform;
	varying vec2 vEmissiveMapUv;
#endif

#ifdef SIXTY_NORMALMAP
	uniform mat3 uNormalMapTransform;
	varying vec2 vNormalMapUv;
#endif
#ifdef USE_MORPHTARGETS

	#ifndef USE_INSTANCING_MORPH

		uniform float morphTargetBaseInfluence;

	#endif

	#ifdef MORPHTARGETS_TEXTURE

		#ifndef USE_INSTANCING_MORPH

			uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];

		#endif

		uniform sampler2DArray morphTargetsTexture;
		uniform ivec2 morphTargetsTextureSize;

		vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {

			int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;
			int y = texelIndex / morphTargetsTextureSize.x;
			int x = texelIndex - y * morphTargetsTextureSize.x;

			ivec3 morphUV = ivec3( x, y, morphTargetIndex );
			return texelFetch( morphTargetsTexture, morphUV, 0 );

		}

	#else

		#ifndef USE_MORPHNORMALS

			uniform float morphTargetInfluences[ 8 ];

		#else

			uniform float morphTargetInfluences[ 4 ];

		#endif

	#endif

#endif

#ifdef USE_SKINNING
	uniform mat4 bindMatrix;
	uniform mat4 bindMatrixInverse;

	uniform highp sampler2D boneTexture;

	mat4 getBoneMatrix( const in float i ) {

		int size = textureSize( boneTexture, 0 ).x;
		int j = int( i ) * 4;
		int x = j % size;
		int y = j / size;
		vec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );
		vec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );
		vec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );
		vec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );

		return mat4( v1, v2, v3, v4 );

	}
#endif

#define SIXTY_UNIFORMS_AREA

void main() {
	#define SIXTY_START_AREA


	#ifdef USE_UV
		vUv = uv;
	#endif
	#ifdef USE_UV1
		vUv1 = uv1;
	#endif


	#ifdef SIXTY_MAP
		vMapUv = (uMapTransform * vec3(SIXTY_MAP_UV, 1.)).xy;
	#endif

	#ifdef SIXTY_ARMMAP
		vArmMapUv = (uArmMapTransform * vec3(SIXTY_ARMMAP_UV, 1.)).xy;
	#endif

	#ifdef SIXTY_AOMAP
		vAoMapUv = (uAoMapTransform * vec3(SIXTY_AOMAP_UV, 1.)).xy;
	#endif

	#ifdef SIXTY_EMISSIVEMAP
		vEmissiveMapUv = (uEmissiveMapTransform * vec3(SIXTY_EMISSIVEMAP_UV, 1.)).xy;
	#endif

	#ifdef SIXTY_NORMALMAP
		vNormalMapUv = (uNormalMapTransform * vec3(SIXTY_NORMALMAP_UV, 1.)).xy;
	#endif	

	vec3 objectNormal = normal;
	vec3 transformedNormal = objectNormal;
	vec3 transformed = position;

	#ifdef USE_MORPHTARGETS

		// morphTargetBaseInfluence is set based on BufferGeometry.morphTargetsRelative value:
		// When morphTargetsRelative is false, this is set to 1 - sum(influences); this results in position = sum((target - base) * influence)
		// When morphTargetsRelative is true, this is set to 1; as a result, all morph targets are simply added to the base after weighting
		transformed *= morphTargetBaseInfluence;

		#ifdef MORPHTARGETS_TEXTURE

			for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {

				if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];

			}

		#else

			transformed += morphTarget0 * morphTargetInfluences[ 0 ];
			transformed += morphTarget1 * morphTargetInfluences[ 1 ];
			transformed += morphTarget2 * morphTargetInfluences[ 2 ];
			transformed += morphTarget3 * morphTargetInfluences[ 3 ];

			#ifndef USE_MORPHNORMALS

				transformed += morphTarget4 * morphTargetInfluences[ 4 ];
				transformed += morphTarget5 * morphTargetInfluences[ 5 ];
				transformed += morphTarget6 * morphTargetInfluences[ 6 ];
				transformed += morphTarget7 * morphTargetInfluences[ 7 ];

			#endif

		#endif

	#endif

	#ifdef USE_MORPHNORMALS

			// morphTargetBaseInfluence is set based on BufferGeometry.morphTargetsRelative value:
			// When morphTargetsRelative is false, this is set to 1 - sum(influences); this results in normal = sum((target - base) * influence)
			// When morphTargetsRelative is true, this is set to 1; as a result, all morph targets are simply added to the base after weighting
			objectNormal *= morphTargetBaseInfluence;

			#ifdef MORPHTARGETS_TEXTURE

				for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {

					if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];

				}

			#else

				objectNormal += morphNormal0 * morphTargetInfluences[ 0 ];
				objectNormal += morphNormal1 * morphTargetInfluences[ 1 ];
				objectNormal += morphNormal2 * morphTargetInfluences[ 2 ];
				objectNormal += morphNormal3 * morphTargetInfluences[ 3 ];

			#endif

		#endif

		#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )

		// morphTargetBaseInfluence is set based on BufferGeometry.morphTargetsRelative value:
		// When morphTargetsRelative is false, this is set to 1 - sum(influences); this results in normal = sum((target - base) * influence)
		// When morphTargetsRelative is true, this is set to 1; as a result, all morph targets are simply added to the base after weighting
		vColor *= morphTargetBaseInfluence;

		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {

			#if defined( USE_COLOR_ALPHA )

				if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];

			#elif defined( USE_COLOR )

				if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];

			#endif

		}

	#endif

	#ifdef USE_INSTANCING_MORPH

		float morphTargetInfluences[MORPHTARGETS_COUNT];

		float morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;

		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {

			morphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;

		}
	#endif 

	#ifdef USE_SKINNING
		mat4 boneMatX = getBoneMatrix( skinIndex.x );
		mat4 boneMatY = getBoneMatrix( skinIndex.y );
		mat4 boneMatZ = getBoneMatrix( skinIndex.z );
		mat4 boneMatW = getBoneMatrix( skinIndex.w );

		vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );

		vec4 skinned = vec4( 0.0 );
		skinned += boneMatX * skinVertex * skinWeight.x;
		skinned += boneMatY * skinVertex * skinWeight.y;
		skinned += boneMatZ * skinVertex * skinWeight.z;
		skinned += boneMatW * skinVertex * skinWeight.w;

		transformed = ( bindMatrixInverse * skinned ).xyz;

		mat4 skinMatrix = mat4( 0.0 );
		skinMatrix += skinWeight.x * boneMatX;
		skinMatrix += skinWeight.y * boneMatY;
		skinMatrix += skinWeight.z * boneMatZ;
		skinMatrix += skinWeight.w * boneMatW;
		skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;

		objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;

		#ifdef USE_TANGENT

			objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;

		#endif
	#endif

	#ifdef USE_INSTANCING
		mat3 im = mat3(instanceMatrix);
		transformedNormal /= vec3(dot(im[0],im[0]), dot(im[1],im[1]), dot(im[2],im[2]));
		transformedNormal = im * transformedNormal;
	#endif
	
	transformedNormal = normalMatrix * transformedNormal;

	vNormal = normalize(transformedNormal);

	#define SIXTY_TRANSFORMED_AREA

	vec4 mvPosition = vec4(transformed, 1.);
	
	#ifdef USE_INSTANCING
		#define SIXTY_INSTANCING_START_AREA
		
		mvPosition = instanceMatrix * mvPosition;
	#endif

	mvPosition = modelViewMatrix * mvPosition;

    vViewPosition = -mvPosition.xyz;

	gl_Position = projectionMatrix * mvPosition;

	#define SIXTY_END_AREA

	#define DEBUG_NONE 0
#define DEBUG_UV 1
#define DEBUG_UV1 2
#define DEBUG_UV2 3
#define DEBUG_UV3 4
#define DEBUG_NORMAL_TEXTURE 5
#define DEBUG_NORMAL_SHADING 6
#define DEBUG_NORMAL_GEOMETRY 7
#define DEBUG_TANGENT 8
#define DEBUG_BITANGENT 9
#define DEBUG_ALPHA 10
#define DEBUG_OCCLUSION 11
#define DEBUG_EMISSIVE 12
#define DEBUG_METALLIC 13
#define DEBUG_ROUGHNESS 14
#define DEBUG_BASE_COLOR 15
#define DEBUG_RADIANCE 16
#define DEBUG_IBL_IRRADIANCE 17

#ifdef DEBUG
    #if DEBUG == DEBUG_UV1 && defined(USE_UV1)
        vUv1 = uv1;
    #endif

    #if DEBUG == DEBUG_UV2 && defined(USE_UV2)
        vUv2 = uv2;
    #endif

    #if DEBUG == DEBUG_UV3 && defined(USE_UV3)
        vUv3 = uv3;
    #endif
#endif
}`;

                            export default {
                                use: (el) => {
                                    const instance = el.material || el;
                                    instance['vertexShader'] = shader;
                                    instance.needsUpdate = true;
                                    return el;
                                }
                            }
                        